import AUStates from './ja-JP/AU-states.json.js';
import CAStates from './ja-JP/CA-states.json.js';
import CNStates from './ja-JP/CN-states.json.js';
import CompanySize from './ja-JP/company-size.json.js';
import CompanyType from './ja-JP/company-type.json.js';
import countries from './ja-JP/countries.json.js';
import DEStates from './ja-JP/DE-states.json.js';
import HKStates from './ja-JP/HK-states.json.js';
import INStates from './ja-JP/IN-states.json.js';
import industry from './ja-JP/industry.json.js';
import interests from './ja-JP/interests.json.js';
import jobRole from './ja-JP/job-role.json.js';
import levelOfAWSUsage from './ja-JP/level-of-aws-usage.json.js';
import projectTimeline from './ja-JP/project-timeline.json.js';
import PTStates from './ja-JP/PT-states.json.js';
import USStates from './ja-JP/US-states.json.js';
import useCase from './ja-JP/use-case.json.js';
import languagePreference from './ja-JP/language-preference.json.js';
import Navatar from '../ja-JP/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
